import {FC, useContext, useEffect, useState} from 'react'
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import LoginPage from '../pages/common/auth/login.page'
import SignupPage from '../pages/common/signup/signup.page'
import { AuthContext } from '../providers/AuthProvider';
import { VendorPrivateRoutes } from './vendor.private-routes.router';
import { SuperAdminPrivateRoutes } from './super-admin.private-routes.router';
import { ACCOUNT_ROUTES, isAccountPath } from './account-routes';
import { SIGNUP_PATH } from './account-paths';

const SubRouting: FC = (props: any) => {
    const { isAuthenticated, isSuperAdmin } = useContext(AuthContext);
    const location = useLocation()
    const [initialLocation, setInitialLocation] = useState("/")

    useEffect(() => {
        setInitialLocation("/dashboard")
    }, [])

    if (isAccountPath(location.pathname)) {
        return <Routes>
            {ACCOUNT_ROUTES.map(({ path, element }) => <Route key={path} path={path} element={element} />)}
        </Routes>
    }

    if(isAuthenticated){
        if(isSuperAdmin) 
            return <Routes>
                <Route path="/" element={<Navigate to="/dashboard" />} />
                <Route path="/login" element={<Navigate to={initialLocation} />} />
                <Route path={SIGNUP_PATH} element={<Navigate to="/dashboard" replace />} />
                <Route path="/*" element={<SuperAdminPrivateRoutes />} />
            </Routes>
        return <Routes>
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route path="/login" element={<Navigate to={initialLocation} />} />
            {/* Signed in already (or just signed up): straight into the app. */}
            <Route path={SIGNUP_PATH} element={<Navigate to="/dashboard" replace />} />
            <Route path="/*" element={<VendorPrivateRoutes />} />
        </Routes>
    } else {
        return <Routes>
            <Route path="/login" element={<LoginPage />} />
            {/* "Start for free" from the landing page. */}
            <Route path={SIGNUP_PATH} element={<SignupPage />} />
            <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
    }
}

const AuthRouter: FC = (props: any) => {

   return (
        <SubRouting {...props} />
   )
}

export { AuthRouter }
